export const RETURN_TO_PARAM = 'returnTo';

const LOGIN_PATH = '/account/login';

// Only in-app paths are accepted, so a crafted link can't send the user to another site
// or back into the login flow after signing in.
export const sanitizeReturnTo = (value: unknown): string | null => {
    if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//') || value.includes('\\')) {
        return null;
    }

    if (/^\/(account|login)(\/|\?|#|$)/.test(value)) {
        return null;
    }

    return value;
};

export const getCurrentPath = (): string =>
    `${window.location.pathname}${window.location.search}${window.location.hash}`;

export const getLoginUrl = (returnTo?: string | null): string => {
    const safeReturnTo = sanitizeReturnTo(returnTo);

    return safeReturnTo ? `${LOGIN_PATH}?${RETURN_TO_PARAM}=${encodeURIComponent(safeReturnTo)}` : LOGIN_PATH;
};
